import { isDevMode } from '@/lib/is-dev-mode';
import { useEffect } from 'react';

function getViewportHeight(): number {
	const webApp = window.Telegram?.WebApp;
	if (webApp?.viewportStableHeight) {
		return webApp.viewportStableHeight;
	}
	return window.innerHeight;
}

function applyViewportHeight() {
	document.documentElement.style.setProperty('--app-height', `${getViewportHeight()}px`);
}

export function useTelegramViewport() {
	useEffect(() => {
		applyViewportHeight();

		if (isDevMode) {
			const onResize = () => applyViewportHeight();
			window.addEventListener('resize', onResize);
			return () => window.removeEventListener('resize', onResize);
		}

		const webApp = window.Telegram?.WebApp;
		if (!webApp) {
			const onResize = () => applyViewportHeight();
			window.addEventListener('resize', onResize);
			return () => window.removeEventListener('resize', onResize);
		}

		webApp.disableVerticalSwipes?.();

		const onViewportChanged = () => applyViewportHeight();
		webApp.onEvent('viewportChanged', onViewportChanged);

		const onResize = () => applyViewportHeight();
		window.addEventListener('resize', onResize);

		return () => {
			webApp.offEvent('viewportChanged', onViewportChanged);
			window.removeEventListener('resize', onResize);
		};
	}, []);
}
